import { COMPANION_FIELD_ROWS } from "@/lib/companionFields";
import { formatGuestFieldValue } from "@/lib/inquiryDisplay";
import type { BookingCompanion } from "@/types/camping";

function roleLabel(role: BookingCompanion["role"], index: number): string {
  return role === "child" ? `Kind ${index + 1}` : `Erwachsene/r ${index + 1}`;
}

type Props = {
  companions: BookingCompanion[] | null | undefined;
  className?: string;
  hideTitle?: boolean;
};

export function BookingCompanionsPanel({ companions, className, hideTitle }: Props) {
  if (!companions?.length) return null;

  let adultIndex = 0;
  let childIndex = 0;

  return (
    <div className={className ?? "space-y-3 border-t border-separator pt-3"}>
      {!hideTitle ? <p className="text-sm font-medium text-label">Mitreisende</p> : null}
      <ul className="space-y-3">
        {companions.map((c, i) => {
          const slotIndex = c.role === "child" ? childIndex++ : adultIndex++;
          const title = roleLabel(c.role, slotIndex);
          const rows = COMPANION_FIELD_ROWS.map((field) => {
            const value = c[field.key];
            if (!value) return null;
            const display =
              field.key === "date_of_birth"
                ? formatGuestFieldValue(field.key, String(value))
                : String(value);
            return (
              <li key={field.key} className="text-sm text-label-secondary">
                <span className="text-label">{field.label}:</span> {display}
              </li>
            );
          }).filter(Boolean);
          if (rows.length === 0) return null;
          return (
            <li
              key={`${c.role}-${i}`}
              className="rounded-lg border border-separator bg-fill-tertiary px-3 py-2"
            >
              <p className="text-sm font-medium text-label">{title}</p>
              <ul className="mt-1 space-y-0.5">{rows}</ul>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
